var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('MenuLoader'),_c('MenuHeader'),_c('MenuContacts'),_c('MenuNavigation',{attrs:{"nav":_vm.choose_section},on:{"shooseNavItem":_vm.onChooseNavItem}}),(_vm.choose_section == 'Головна')?_c('KichenBar',{on:{"pickMenu":_vm.onPickMenu}}):(
      _vm.choose_section == 'Кухня' || _vm.choose_section == 'Бар'
      // choose_section == 'Суші'
    )?_c('MenuCategories',{attrs:{"categories":_vm.menu_categories},on:{"chooseEl":_vm.onChooseEl}}):(
      _vm.choose_section == 'Чаї' ||
      _vm.choose_section == 'Безалкогольні напої' ||
      _vm.choose_section == 'Алкоголь' ||
      _vm.choose_section == 'Коктейлі'
    )?_c('BarCategories',{attrs:{"categories":_vm.bar_categories},on:{"chooseEl":_vm.onChooseEl}}):(_vm.choose_section == 'доставка')?_c('MenuDelivery',{attrs:{"categories":_vm.menu_categories},on:{"chooseEl":_vm.onChooseEl}}):_c('MenuDishes',{attrs:{"dishes":_vm.ObjDataValues}}),_c('MenuFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }